/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreorderPriceInfoDto
 */
export interface PreorderPriceInfoDto {
    /**
     * Количество ночей
     * @type {number}
     * @memberof PreorderPriceInfoDto
     */
    nights: number;
    /**
     * Количество взрослых
     * @type {number}
     * @memberof PreorderPriceInfoDto
     */
    adults: number;
    /**
     * Количество детей
     * @type {number}
     * @memberof PreorderPriceInfoDto
     */
    children: number;
    /**
     * Общая стоимость
     * @type {number}
     * @memberof PreorderPriceInfoDto
     */
    totalPrice: number;
    /**
     * Бонусы
     * @type {number}
     * @memberof PreorderPriceInfoDto
     */
    totalBonus?: number;
    /**
     * Сумма предоплаты
     * @type {number}
     * @memberof PreorderPriceInfoDto
     */
    prepayment: number;
    /**
     * Доля предоплаты от стоимости жилья
     * @type {number}
     * @memberof PreorderPriceInfoDto
     */
    prepaymentCoefficient: number;
}

/**
 * Check if a given object implements the PreorderPriceInfoDto interface.
 */
export function instanceOfPreorderPriceInfoDto(value: object): value is PreorderPriceInfoDto {
    if (!('nights' in value) || value['nights'] === undefined) return false;
    if (!('adults' in value) || value['adults'] === undefined) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    if (!('totalPrice' in value) || value['totalPrice'] === undefined) return false;
    if (!('prepayment' in value) || value['prepayment'] === undefined) return false;
    if (!('prepaymentCoefficient' in value) || value['prepaymentCoefficient'] === undefined) return false;
    return true;
}

export function PreorderPriceInfoDtoFromJSON(json: any): PreorderPriceInfoDto {
    return PreorderPriceInfoDtoFromJSONTyped(json, false);
}

export function PreorderPriceInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreorderPriceInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nights': json['nights'],
        'adults': json['adults'],
        'children': json['children'],
        'totalPrice': json['totalPrice'],
        'totalBonus': json['totalBonus'] == null ? undefined : json['totalBonus'],
        'prepayment': json['prepayment'],
        'prepaymentCoefficient': json['prepaymentCoefficient'],
    };
}

  export function PreorderPriceInfoDtoToJSON(json: any): PreorderPriceInfoDto {
      return PreorderPriceInfoDtoToJSONTyped(json, false);
  }

  export function PreorderPriceInfoDtoToJSONTyped(value?: PreorderPriceInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nights': value['nights'],
        'adults': value['adults'],
        'children': value['children'],
        'totalPrice': value['totalPrice'],
        'totalBonus': value['totalBonus'],
        'prepayment': value['prepayment'],
        'prepaymentCoefficient': value['prepaymentCoefficient'],
    };
}

